// extracted by mini-css-extract-plugin
export default {"container":"NJPCWEDeVJzefvX7cnLw"};